import { useAuthStore } from '../store';
import { evaluateClientPolicy } from '../auth/policies.js';

/**
 * Check if the current user satisfies a named policy.
 *
 * Usage:
 *   const canTrade = usePolicy('CanTrade');
 */
export function usePolicy(policyName: string): boolean {
  const permissions = useAuthStore((s) => s.user?.permissions ?? []);
  const organizationPlan = useAuthStore((s) => s.user?.organizationPlan ?? null);
  return evaluateClientPolicy(policyName, permissions, organizationPlan);
}

/**
 * Check if the current user satisfies ANY of the listed policies.
 */
export function useAnyPolicy(...policyNames: string[]): boolean {
  const permissions = useAuthStore((s) => s.user?.permissions ?? []);
  const organizationPlan = useAuthStore((s) => s.user?.organizationPlan ?? null);
  return policyNames.some((name) => evaluateClientPolicy(name, permissions, organizationPlan));
}
